module.exports = __webpack_public_path__ + "img/logo_small.67ca08e3.png";